import styled from 'styled-components';

export const CheckboxWrapper = styled.div<{
  $haserror?: boolean;
  $isFullWidth?: boolean;
}>`
  width: 100%;
`;
